import React, { FC, useCallback } from 'react';
import useLocalStorage from 'react-localstorage-hook';
import { useNavigate } from 'react-router';

import { Box, Typography } from '@mui/material';

import { modalActions } from '@contexts/common/ModalContext';

import Button from '@components/common/Button';
import Checkbox from '@components/common/Checkbox';
import ModalWrapper from '@components/common/Modal/ModalWrapper';
import Confetti from '@components/vaults/Confetti';

import { HIDE_CREATED_VAULT_MODAL } from '@constants/common/localStorage.constants';
import { PATH_VAULTS } from '@constants/common/routes.constants';

import { CreatedVaultModalProps } from '@app-types/common/modal.types';

import useStyles from './styles.module';

const CreatedVaultModal: FC<CreatedVaultModalProps> = ({ vaultId }) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [hideModal, onHideModal] = useLocalStorage(HIDE_CREATED_VAULT_MODAL);

  const handleNavigateToVault = useCallback(() => {
    modalActions.hide();

    navigate(`${PATH_VAULTS}/${vaultId}`);
  }, [navigate, vaultId]);

  const handleShowModal = useCallback(() => {
    onHideModal(!hideModal);
  }, [hideModal, onHideModal]);

  return (
    <>
      <ModalWrapper
        title="Your vault has been created!"
        className={classes.modal}
      >
        <Typography
          variant="body1"
          color={(theme) => theme.primary.p2}
          textAlign="center"
          className={classes.description}
        >
          You may now add funds into your new vault by either zapping in or
          directly depositing the underlying assets. Please note, if you wish to
          allow others to join the vault and share in the harvest costs
          it&apos;s recommended that you publish the vault prior to depositing
          funds.
        </Typography>
        <Button fullWidth onClick={handleNavigateToVault}>
          Go to VAULT
        </Button>
        <Box className={classes.checkboxWrapper}>
          <Checkbox
            checked={hideModal}
            color="primary"
            onClick={handleShowModal}
          />
          <Typography variant="body1" color={(theme) => theme.secondary.s3}>
            Don’t show again
          </Typography>
        </Box>
      </ModalWrapper>
      <Confetti />
    </>
  );
};

export default CreatedVaultModal;
